import { DtText } from '@ow/ditto-core'

const { config } = DtText

export { default as Render } from './render'
export { config }
